<template>
	<div>
		<div class="row">
            <div class="col-xs-0 col-sm-2 col-lg-2">
                <Multiselect 
                    v-if="options.pdc"
                    v-model="filter.location"
                    class="highlightLocationFilter"
                    :options="options.pdc"
                    placeholder="All PDC"
                />
            </div>
            <div class="col-xs-12 col-sm-10 col-lg-8 offset-lg-2">
                <div class="row ">
                    <div class="col-lg col-sm col-xs-12 mb-2" v-for="(buttonName,index ) in buttonArray">
                        <input type="button" class="btn  float-right"  :class="{ 'btn-outline-primary' : filter.period != index + 1 , 'btn-primary' : filter.period == index + 1}"  style="width:100%" @click="filter.period = index + 1" :value="buttonName">
                    </div>

                </div>
            </div>
        </div>
  

        <div class="row mt-4">
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats border border-secondary" style="background-color:#80D6FF">
                    <div class="stats-info">
                        <p v-if="!apiReady">Loading....</p>
                        <p v-else>{{stats.total ? numberWithCommas(stats.total) : 0}}</p>
                        <h4>TOTAL QR REGISTERED</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats border border-secondary" style="background-color:#FBA2A8">
                    <div class="stats-info">
                        <p v-if="!apiReady">Loading....</p>
                        <p v-else>{{stats.total_morning ? numberWithCommas(stats.total_morning) : 0}}</p>
                        <h4>TOTAL SHIFT SIANG</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats border border-secondary" style="background-color:#6FD9D1">
                    <div class="stats-info">
                        <p v-if="!apiReady">Loading....</p>
                        <p v-else>{{stats.total_night ? numberWithCommas(stats.total_night) : 0}}</p>
                        <h4>TOTAL SHIFT MALAM</h4>
                    </div>
                </div>
            </div>
			
        </div>

        <totalQRRegisteredByVehicleType style="margin-left:10px" class="mt-4" :data="totalVehicleRegisteredByType" :isUpdate="isUpdate"></totalQRRegisteredByVehicleType>
	</div>
</template>

<script>
    import qs from 'qs';
    import Multiselect from 'vue-multiselect';

    import totalQRRegisteredByVehicleType from './charts/totalQRRegisteredByVehicleType'
    import * as am4core from "@amcharts/amcharts4/core";

    export default {
        data(){
            return {
                stats : {
                    total : 0,
                    total_morning : 0,
                    total_night : 0
                },
                options : {
                    pdc : this.$store.getters.getPdc,
                },
                filter : {
                    period : 1,
                    location : null,
                },
                apiReady : false,
                buttonArray : ['Month To Date' , 'Last Month' , 'Year To Date' , 'Last Year' , 'All Time'],
                totalVehicleRegisteredByType : {},
                isUpdate : 0
            }
        },
        components : {
            totalQRRegisteredByVehicleType,
            Multiselect,
        },
        mounted(){

        },
        watch : {
            'filter' : {
                deep : true,
                immediate : true,
                handler : 'search',
            }
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
        },
        methods : {
            numberWithCommas(x) {
                return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            search(){
                this.$http.get(`/api/dashboard${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
                .then((resp)=>{
                    var data = resp.data.data;

                    this.stats = data.highlight[0];
                    this.totalVehicleRegisteredByType = data.totalVehicleRegisteredByType
                    this.apiReady = true;
                    this.isUpdate++;
                })
                .catch((err)=>{
                    console.log(err);
                })
            }
        }
    }
</script>

<style>
    .highlightLocationFilter .multiselect__tags {
        height: 34px;
    }
</style>

<style scoped>
    .stats-info p{
        color:#fff !important;
    }

    .stats-info h4{
        color: #fff !important;
        font-weight: bold;
    }
</style>